// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"a93772cc","43":"c4d54bb9","94":"c060f753","453":"566bb640","526":"1f598e5c","571":"e20169cc","656":"153122c8","716":"ae8e7a40","942":"bd6659f4"}[chunkId] + ".chunk.js";
};